import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { FootercompComponent } from './footercomp/footercomp.component';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { Bfi10Component } from './bfi10/bfi10.component';
import { UserPopoverComponent } from './header/user-popover/user-popover.component';
import { SearchPopoverComponent } from './header/search-popover/search-popover.component';
import { PricingcompComponent } from './pricingcomp/pricingcomp.component';
import { EditProfilePopoverComponent } from './profile/edit-profile-popover/edit-profile-popover.component';
import { UserlistComponent } from './userlist/userlist.component';
import { BeeexpertUserPipe, UserRolePipe } from '../utils/custom-pipes-pipe';
import { SetUserRoleComponent } from './companyadmin/setuserrole/setuserrole.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InviteUserComponent } from './companyadmin/inviteuser/inviteuser.component';
import { WarningsComponent } from './warnings/warnings.component';
import { SelectTimeperiodComponent } from './select-timeperiod/select-timeperiod.component';
import { ShowHidePasswordComponent } from './show-hide-password/show-hide-password.component';
import { ImageUploadComponent } from './image-upload/image-upload.component';
import { ShareFormComponent } from './share-form/share-form.component';
import { SpartaxIdentityComponent } from './forms/controls/forms-spartax-questionnaire/spartax-identity/spartax-identity.component';
import { SpartaxMaritialStatusComponent } from './forms/controls/forms-spartax-questionnaire/spartax-maritial-status/spartax-maritial-status.component';
import { SpartaxChildrenComponent } from './forms/controls/forms-spartax-questionnaire/spartax-children/spartax-children.component';
import { SpartaxDisabilitiesComponent } from './forms/controls/forms-spartax-questionnaire/spartax-disabilities/spartax-disabilities.component';
import { SpartaxAdditionalQuestionsComponent } from './forms/controls/forms-spartax-questionnaire/spartax-additional-questions/spartax-additional-questions.component';
import { SpartaxPlaceOrderComponent } from './forms/controls/forms-spartax-questionnaire/spartax-place-order/spartax-place-order.component';
import { SpartaxFollowUpDialogComponent } from './forms/controls/forms-spartax-questionnaire/spartax-follow-up-dialog/spartax-follow-up-dialog.component';
import { SpartaxOrderSuccessDialogComponent } from './forms/controls/forms-spartax-questionnaire/spartax-order-success-dialog/spartax-order-success-dialog.component';
import { ProfilecompComponent } from './profilecomp/profilecomp.component';
import { CanvasPopupComponent } from './canvas-popup/canvas-popup.component';
import { SpartaxBottomComponent } from './forms/spartax-bottom/spartax-bottom.component';
import { SpartaxHeaderComponent } from './spartax-header/spartax-header.component';
import { CreatenewcategoryPopupComponent } from './createnewcategory-popup/createnewcategory-popup.component';
import { SpartaxIncomeComponent } from './forms/controls/forms-spartax-questionnaire/spartax-income/spartax-income.component';
import { MagirusConditionsPopupComponent } from './magirus-conditions-popup/magirus-conditions-popup.component';
import { MagirusHeaderComponent } from './magirus-header/magirus-header.component';
import { EditAnzPopupComponent } from './edit-anz-popup/edit-anz-popup.component';
import { MagirusErrorDragAndDropComponent } from './magirus-error-drag-and-drop/magirus-error-drag-and-drop.component';
import { SpartaxProcedureComponent } from './forms/controls/forms-spartax-questionnaire/spartax-procedure/spartax-procedure.component';
import { SpartaxCQProcedureComponent } from './forms/controls/forms-spartax-questionnaire/spartax-cq-procedure/spartax-cq-procedure.component';
import { SpartaxCQMasterComponent } from './forms/controls/forms-spartax-questionnaire/spartax-cq-master/spartax-cq-master.component';
import { SpartaxCQPlaceOrderComponent } from './forms/controls/forms-spartax-questionnaire/spartax-cq-place-order/spartax-cq-place-order.component';
import { PositionGroupsManagerComponent } from './position-groups-manager/position-groups-manager.component';
import { MagirusCalculationComponentComponent } from './magirus-calculation-component/magirus-calculation-component.component';

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    FootercompComponent,
    PricingcompComponent,
    Bfi10Component,
    MagirusConditionsPopupComponent,
    EditAnzPopupComponent,
    MagirusErrorDragAndDropComponent,
    PositionGroupsManagerComponent,
    UserPopoverComponent,
    SearchPopoverComponent,
    EditProfilePopoverComponent,
    UserlistComponent,
    SetUserRoleComponent,
    InviteUserComponent,
    BeeexpertUserPipe,
    UserRolePipe,
    WarningsComponent,
    SelectTimeperiodComponent,
    ShowHidePasswordComponent,
    ImageUploadComponent,
    ShareFormComponent,
    SpartaxProcedureComponent,
    SpartaxCQProcedureComponent,
    SpartaxCQMasterComponent,
    SpartaxCQPlaceOrderComponent,
    SpartaxIdentityComponent,
    SpartaxMaritialStatusComponent,
    SpartaxChildrenComponent,
    SpartaxIncomeComponent,
    SpartaxDisabilitiesComponent,
    SpartaxAdditionalQuestionsComponent,
    SpartaxPlaceOrderComponent,
    SpartaxFollowUpDialogComponent,
    SpartaxOrderSuccessDialogComponent,
    ProfilecompComponent,
    CanvasPopupComponent,
    SpartaxBottomComponent,
    SpartaxHeaderComponent,
    MagirusHeaderComponent,
    CreatenewcategoryPopupComponent
  ,MagirusCalculationComponentComponent
  ],
  imports: [CommonModule, IonicModule, FontAwesomeModule, RouterModule, FormsModule, ReactiveFormsModule],
  exports: [
    HeaderComponent,
    FooterComponent,
    FootercompComponent,
    PricingcompComponent,
    Bfi10Component,
    EditAnzPopupComponent,
    MagirusErrorDragAndDropComponent,
    MagirusConditionsPopupComponent,
    PositionGroupsManagerComponent,
    UserPopoverComponent,
    SearchPopoverComponent,
    EditProfilePopoverComponent,
    UserlistComponent,
    SetUserRoleComponent,
    InviteUserComponent,
    BeeexpertUserPipe,
    UserRolePipe,
    WarningsComponent,
    SelectTimeperiodComponent,
    ShowHidePasswordComponent,
    ImageUploadComponent,
    ShareFormComponent,
    SpartaxProcedureComponent,
    SpartaxCQProcedureComponent,
    SpartaxCQMasterComponent,
    SpartaxCQPlaceOrderComponent,
    SpartaxIdentityComponent,
    SpartaxMaritialStatusComponent,
    SpartaxChildrenComponent,
    SpartaxIncomeComponent,
    SpartaxDisabilitiesComponent,
    SpartaxAdditionalQuestionsComponent,
    SpartaxPlaceOrderComponent,
    SpartaxFollowUpDialogComponent,
    SpartaxOrderSuccessDialogComponent,
    ProfilecompComponent,
    CanvasPopupComponent,
    SpartaxBottomComponent,
    SpartaxHeaderComponent,
    MagirusHeaderComponent,
    CreatenewcategoryPopupComponent
  ,MagirusCalculationComponentComponent
  ],
})
export class SharedComponentsModule { }
